import { createFileRoute } from "@tanstack/react-router"
import { UgcAdsLandingPage } from "./-HomePage"

export const Route = createFileRoute("/")({
  component: UgcAdsLandingPage,
})
